import React, {ReactElement, useEffect, useState} from "react";
import {Navigate, Outlet} from "react-router";
import * as http from '../../handlers/http';
import LoadingPage from "../../components/pages/LoadingPage";
import {PAGES_PATHS} from "../../Entrypoint";
import Page from "../../components/pages/Page";
import {ErrorCode} from "../../types/Error";
import {ErrorParam} from "../../components/pages/ErrorPage";

export default function ConfigurationsGate(): ReactElement {

	const [valid, setValid] = useState<boolean | null>(null)

	useEffect(() => {
		http.get<void>("/web/check-configs")
				.then(() => setValid(true))
				.catch(() => setValid(false))
	}, []);

	return (
			<React.Fragment>
				{valid == null
						? <LoadingPage/>
						: valid ? (
								<Page>
									<Outlet/>
								</Page>
						) : (
								<Navigate
										to={`/${PAGES_PATHS.ERROR}?${ErrorParam.KEY}=${ErrorCode.ILLEGAL_CONFIGURATIONS_STATE}`}
										replace={true}/>
						)
				}
			</React.Fragment>
	)
}